import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { WorkbenchPage } from './pages/WorkbenchPage';
export function App() {
  const [hasStarted, setHasStarted] = useState(false);
  return <div className="antialiased text-mondrian-black" data-id="element-0">
      {!hasStarted ? <LandingPage onStart={() => setHasStarted(true)} data-id="element-1" /> : <WorkbenchPage onGoHome={() => setHasStarted(false)} data-id="element-2" />}
    </div>;
}